import React from 'react';
import { Check, ShieldCheckIcon, LockIcon, CreditCardIcon, ZapIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function PricingSection() {
  return <section id="pricing" className="bg-gradient-to-br from-[#1F3D2B] to-[#2E5A3E] py-6 md:py-8 px-3 border-b border-[#1F3D2B]" data-id="element-151">
      <div className="max-w-4xl mx-auto" data-id="element-152">
        <h2 className="text-2xl md:text-3xl font-black text-white text-center mb-4 uppercase tracking-tight" data-id="element-153">
          🎯 OFERTA
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 items-stretch" data-id="element-154">
          {/* Kit Completo */}
          <div className="bg-[#102A1F] rounded-xl p-4 flex flex-col h-full border border-[#1F3D2B] shadow-lg" data-id="element-155">
            <h3 className="text-base md:text-lg font-black text-white uppercase mb-2 text-center" data-id="element-156">
              🌾 KIT COMPLETO GEOGRAFÍA RURAL LISTA
            </h3>
            <div className="text-center mb-3" data-id="element-157">
              <div className="text-3xl md:text-4xl font-black text-[#D4A843]" data-id="element-158">
                $25.990
              </div>
            </div>
            <ul className="space-y-2 mb-4 flex-grow" data-id="element-159">
              <li className="flex items-center gap-2 text-white text-xs md:text-sm font-bold" data-id="element-160">
                <Check className="w-4 h-4 text-[#74C69D] flex-shrink-0" strokeWidth={3} data-id="element-161" />
                6 tomos
              </li>
              <li className="flex items-center gap-2 text-white text-xs md:text-sm font-bold" data-id="element-162">
                <Check className="w-4 h-4 text-[#74C69D] flex-shrink-0" strokeWidth={3} data-id="element-163" />
                4 bonos
              </li>
            </ul>
            <CTAButton href="https://docentes-felices.myshopify.com/cart/51063334633778:1" variant="primary" fullWidth className="py-3 text-sm" data-id="element-164">
              ACCEDER AHORA
            </CTAButton>
          </div>

          {/* Kit + Sistema Pro */}
          <div className="bg-[#102A1F] rounded-xl p-4 flex flex-col h-full relative border-2 border-[#D4A843] shadow-[0_0_30px_rgba(212,168,67,0.5)] transform scale-105 z-10" data-id="element-165">
            <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-[#D4A843] text-[#000000] font-black px-4 py-0.5 rounded-full text-[10px] md:text-xs tracking-widest uppercase whitespace-nowrap z-10 shadow-lg" data-id="element-166">
              RECOMENDADO
            </div>

            <h3 className="text-base md:text-lg font-black text-white uppercase mb-2 mt-1 text-center" data-id="element-167">
              🚀 KIT + SISTEMA PRO
            </h3>

            <div className="text-center mb-3" data-id="element-168">
              <div className="text-3xl md:text-4xl font-black text-[#D4A843]" data-id="element-169">
                $32.990
              </div>
            </div>

            <p className="text-[#74C69D] font-black text-xs mb-2 border-b border-[#1F3D2B] pb-2 text-center" data-id="element-170">
              ✔ Todo lo anterior +
            </p>

            <div className="bg-[#071A14] rounded-lg p-3 mb-3 border border-[#1F3D2B] flex-grow" data-id="element-171">
              <h4 className="font-black text-[#D4A843] text-xs mb-2 uppercase text-center" data-id="element-172">
                💥 SISTEMA PRO DE GEOGRAFÍA RURAL
              </h4>
              <ul className="space-y-1.5" data-id="element-173">
                <li className="flex items-start gap-1.5 text-white text-xs font-bold" data-id="element-174">
                  <Check className="w-3.5 h-3.5 text-[#D4A843] flex-shrink-0 mt-0.5" strokeWidth={3} data-id="element-175" />
                  Planificación completa
                </li>
                <li className="flex items-start gap-1.5 text-white text-xs font-bold" data-id="element-176">
                  <Check className="w-3.5 h-3.5 text-[#D4A843] flex-shrink-0 mt-0.5" strokeWidth={3} data-id="element-177" />
                  Evaluaciones avanzadas
                </li>
                <li className="flex items-start gap-1.5 text-white text-xs font-bold" data-id="element-178">
                  <Check className="w-3.5 h-3.5 text-[#D4A843] flex-shrink-0 mt-0.5" strokeWidth={3} data-id="element-179" />
                  Actividades imprimibles
                </li>
                <li className="flex items-start gap-1.5 text-white text-xs font-bold" data-id="element-180">
                  <Check className="w-3.5 h-3.5 text-[#D4A843] flex-shrink-0 mt-0.5" strokeWidth={3} data-id="element-181" />
                  Aplicación directa en aula
                </li>
              </ul>
            </div>

            <p className="text-center text-[#BFC9C5] font-black text-[10px] md:text-xs mb-3 leading-tight" data-id="element-182">
              👉 Para que tus clases no solo estén armadas…
              <br data-id="element-183" />
              👉 sino que te sientas seguro enseñando
            </p>

            <CTAButton href="https://docentes-felices.myshopify.com/cart/51063372316978:1" variant="primary" fullWidth className="py-3 text-sm" data-id="element-184">
              ACCEDER AHORA
            </CTAButton>
          </div>
        </div>

        <div className="flex flex-wrap justify-center items-center gap-3 md:gap-6 text-white text-[10px] md:text-xs font-bold mt-8" data-id="element-185">
          <div className="flex items-center gap-1" data-id="element-186">
            <LockIcon className="w-4 h-4 text-[#D4A843]" data-id="element-187" /> Pago seguro
          </div>
          <div className="flex items-center gap-1" data-id="element-188">
            <ZapIcon className="w-4 h-4 text-[#D4A843]" data-id="element-189" /> Acceso en minutos
          </div>
          <div className="flex items-center gap-1" data-id="element-190">
            <ShieldCheckIcon className="w-4 h-4 text-[#D4A843]" data-id="element-191" /> Garantía 7
            días
          </div>
          <div className="flex items-center gap-1" data-id="element-192">
            <CreditCardIcon className="w-4 h-4 text-[#D4A843]" data-id="element-193" /> Mercado Pago
          </div>
        </div>
      </div>
    </section>;
}